var map = {
	"./additionalInfoIcon.svg": 604,
	"./arrowBottomIconSharpSmall.svg": 605,
	"./arrowLeftIcon.svg": 606,
	"./arrowMediumTop.svg": 607,
	"./arrowRightIcon.svg": 608,
	"./arrowRightIconSharp.svg": 609,
	"./arrowRightSmallIcon.svg": 610,
	"./arrowScalableIcon.svg": 611,
	"./arrowSelect2.svg": 531,
	"./arrowSelectIcon.svg": 612,
	"./benefit1.svg": 613,
	"./benefit2.svg": 614,
	"./benefit3.svg": 615,
	"./cardsIcon.svg": 616,
	"./circleInfoIcon.svg": 617,
	"./copyIcon copy.svg": 618,
	"./copyIcon.svg": 619,
	"./crossIcon.svg": 620,
	"./crossIcon2.svg": 621,
	"./crossIcon3.svg": 622,
	"./crossIconSmall.svg": 623,
	"./crossSmallIcon.svg": 624,
	"./defaultCategoryIcon.svg": 625,
	"./depNumberIcon.svg": 626,
	"./elfCentralIcon.svg": 627,
	"./errorIcon.svg": 530,
	"./eyeClosedIcon.svg": 628,
	"./eyeOpenIcon.svg": 629,
	"./favoritesIcon.svg": 630,
	"./favoritesLabelIcon.svg": 631,
	"./filterDivider.svg": 632,
	"./filterIcon.svg": 633,
	"./frequencyIcon.svg": 634,
	"./fsAmountIcon.svg": 635,
	"./fullScreenIcon.svg": 636,
	"./gameIcon.svg": 637,
	"./gemIcon.svg": 638,
	"./goldGiftIcon.svg": 639,
	"./hamburgerIcon.svg": 640,
	"./infoIcon.svg": 641,
	"./infoIconSmall.svg": 642,
	"./infoSymbol.svg": 643,
	"./levelBackground.svg": 644,
	"./levelBackgroundNew.svg": 645,
	"./linkIcon.svg": 646,
	"./lockIcon.svg": 647,
	"./lockSharpIcon.svg": 648,
	"./maxBonusAmountIcon.svg": 649,
	"./maxWinFsIcon.svg": 650,
	"./menuIcon.svg": 651,
	"./minDepIcon.svg": 652,
	"./minusIcon.svg": 653,
	"./noTournamentIcon.svg": 654,
	"./playIcon.svg": 655,
	"./plusIcon.svg": 656,
	"./polygon.svg": 657,
	"./preloaderDotsAnimation.svg": 658,
	"./preloaderSpinnerAnimation.svg": 659,
	"./present2Icon.svg": 660,
	"./presentIcon.svg": 661,
	"./promoIcon.svg": 662,
	"./recentIcon.svg": 663,
	"./search2Icon.svg": 664,
	"./search3Icon.svg": 665,
	"./sharpTickIcon copy.svg": 666,
	"./sharpTickIcon.svg": 667,
	"./smallInfoSymbol.svg": 668,
	"./smoothArrowIcon.svg": 669,
	"./successIcon.svg": 670,
	"./supportIcon.svg": 671,
	"./tag1Icon.svg": 672,
	"./tag2Icon.svg": 673,
	"./tag3Icon.svg": 674,
	"./tag4Icon.svg": 675,
	"./tickIcon.svg": 676,
	"./unverified.svg": 677,
	"./verified.svg": 678,
	"./wagerIcon.svg": 679,
	"./wagerTimeIcon.svg": 680,
	"./warningIcon.svg": 681,
	"./zoomIcon.svg": 682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 603;